module.exports = __webpack_public_path__ + "img/courses-2.2f0b93a3.jpg";